module.exports = __webpack_public_path__ + "static/media/PowerIcon.fc4971d7.svg";